import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import trinetraProducts from "./trinetrarx.json";
// import trinetraProducts from "./trinetra.json";
import "./trinetra.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import TopNavBar from "./topNav/TopNavBar";
import Welcome from "./topNav/Welcome";
import FooterWeb from "./topNav/Footer";
// import Comfortaa from'./fonts/Comfortaa/';
// import './fonts/Montserrat_Alternates/';
//import { Category } from "@mui/icons-material";
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';

export const ShowCase = (props) => {
  const [toRender, setToRender] = useState([{ type: "category" }]);
  const [renderTrigger,toggleRenderTrigger] = useState(false);
  const navigate = useNavigate();

  let category = [];
  for (let i = 0; i < trinetraProducts.length; i++) {
    category.push({
      catTitle: trinetraProducts[i]["Category"],
      catLogo: trinetraProducts[i]["catLogo"],
      catDis: trinetraProducts[i]["catDis"]
    });
  }

  category = [...new Map(category.map(item => [item["catTitle"], item])).values()];


  let items;
  if (toRender[toRender.length - 1].type == "category") {
    items = category.map((cat) => {
      return (
        <ProductShowCase
          title={cat.catTitle}
          catLogo={cat.catLogo}
          catDis={cat.catDis}
          linkAtteched={true}
          setToRender={setToRender}
          toRender = {toRender}
          renderTrigger = {renderTrigger}
          toggleRenderTrigger = {toggleRenderTrigger}
        ></ProductShowCase>
      );
    });
  } else {
    let res = filterFunction({ Category: toRender[toRender.length - 1].type }, trinetraProducts);
    console.log("apricots",res)
    items = res.map((prod) => {

      return (
        <ProductShowCase
         smallFontSize={true}
         smallCardSize={true}
          title={prod.Product}
          catLogo={prod.proLogo}
          proLink={prod.proLink}
          linkAtteched={prod.proLink === "#" ? false : true}
          toRender = {toRender}
          setToRender={setToRender}
          renderTrigger = {renderTrigger}
          toggleRenderTrigger = {toggleRenderTrigger}
        >
        </ProductShowCase>
      );
    });
  }

  return <>

    <TopNavBar setToRender={setToRender}
          toRender = {toRender}
          renderTrigger = {renderTrigger}
          toggleRenderTrigger = {toggleRenderTrigger}
          disableBackBtn={toRender[toRender.length - 1].type == "category"}/>
    <Welcome />
    <div className="card-container">{items}</div>
    <FooterWeb />
  </>;
};

const ProductShowCase = (props) => {

  const navigate = useNavigate();

  const whenClicked = (e) => {
    //console.log( e.currentTarget.querySelector('h5').innerHTML)
    //console.log("event : ",e.currentTarget.querySelector('h5').innerHTML)

    //console.log("kkk : ",e.currentTarget.textContent);
    //props.toRender.push({ type: e.currentTarget.querySelector('h5').innerHTML});
    //console.log(props.toRender)
   // props.setToRender(props.toRender);
    //props.toggleRenderTrigger(!props.renderTrigger);
    if(!props.smallFontSize){
      props.toRender.push({ type: e.currentTarget.querySelector('h5').innerHTML});
      props.setToRender(props.toRender);
      props.toggleRenderTrigger(!props.renderTrigger);
    }else{
      if(props.proLink === "#"){
        navigate(props.proLink)
      }else{
      window.open(props.proLink, "_blank")
      }
    }
  };


  return (
    <>
      <div  onClick={whenClicked} className={props.linkAtteched ? "link-true" : "link-false"}>
        <div className={props.smallCardSize ? "float small-card-box" :  "float big-card-box"}>
          <div className="img">
            <img src={props.catLogo} alt="" />
          </div>
          <div className="col-sm-12 title float">
         <h5 className={props.smallFontSize ? "smallFont" :  "bigFont"}>{props.title}</h5>
          <div className="para-box">{props.catDis}</div>
          </div>
            <div className="col-sm-7 float">
              <button type="button" className="button"> View Detail&nbsp;&nbsp;&nbsp;<KeyboardDoubleArrowRightRoundedIcon/></button>
            </div>
        </div>
      </div>
      {/* <h3 onClick={whenClicked}>{props.title}</h3> */}
    </>
  );
};

function filterFunction(filterCriteria, jsonObj) {
  console.log("filterCriteria", filterCriteria)
  let result = [];

  for (let i = 0; i < jsonObj.length; i++) {
    let match = true;
    for (const key in filterCriteria) {
      // if (jsonObj[i][key] == undefined) {
      //     continue;
      // }

      if (filterCriteria[key] !== jsonObj[i][key]) {
        match = false;
      }
    }

    if (match) {
      result.push(JSON.parse(JSON.stringify(jsonObj[i])));
    }
  }

  return result;
}
